// Parse a money string tolerant of a scan/OCR mis-writing a thousands separator as a decimal: "6,440.039"
// (mis-OCR'd) and "6,440,039" (correct) BOTH → 6440039. Returns a Number or null.
// NOTE: money only — do NOT use for tax RATES (a rate like 1.302 has a legit 3-digit fractional part that this
// would collapse); parse rates with parseFloat(replace(/[^0-9.]/g,'')).
//
// ⛔ THE TEST IS THE WHOLE GROUPING PATTERN, NOT THE TAIL. It used to be "does the last group after a . or ,
// have exactly 3 digits" — which never asked whether the string was grouped AT ALL, so it deleted the decimal
// point from any bare 3-decimal value. That multiplied 39715.115 by 1000 → 39715115, and stored a
// $39,715,115 discount on a $397,151.15 tax bill. The evidence for "these separators are thousands" IS that
// the number is grouped: a leading run of 1-3 digits, then groups of EXACTLY 3.
//
//   "6,440.039"   → 6440039     grouped, tail 3 → the OCR case this exists for
//   "1,234,567"   → 1234567     grouped
//   "397,151.15"  → 397151.15   grouped but tail is 2 → a normal money value, separators are thousands
//   "39715.115"   → 39715.115   NOT grouped → a literal 3-decimal number, NOT a mis-OCR'd million
//   "38,900.615"  → 38900615    ⛔ STILL collapses, and that is correct: once a grouping comma is present the
//                               thousands reading is the likelier one. The fix rescues the UNGROUPED case
//                               (which is what the extractor emits — it is asked for "number only", so its
//                               output carries no separators); a grouped 3-decimal string stays ambiguous by
//                               nature and this resolves it the same way it always did.
//
// ⛔ THE TRADE, stated because it is one and not a free win: if OCR ever drops a leading group INSTEAD of
// converting a separator — 1,234,039 arriving as "1234.039" — this now under-reads by 1000× where the old
// tail test read it correctly. Judged rarer (a comma→period slip needs a comma to be there in the first
// place) and it fails SMALL rather than large, but it is a real exchange of one failure mode for another.
//
// European format ("1.234,56" → 1.23456) is already wrong here and deliberately left alone: US bills only,
// and disambiguating it needs locale knowledge this parser does not have.
const GROUPED_THOUSANDS = /^-?\d{1,3}([.,]\d{3})+$/;

export function moneyNum(v) {
  let s = String(v ?? '').replace(/[$\s]/g, '');
  if (!s) return null;
  s = GROUPED_THOUSANDS.test(s) ? s.replace(/[.,]/g, '') : s.replace(/,/g, '');
  const n = parseFloat(s);
  return isNaN(n) ? null : n;
}
